import BaseService from "../BaseService";
import _ from "lodash";

class LoginServices extends BaseService {
    me = async () => {
        var data = await this._api.post("account/me",);
        return data;
    }

    loginWorkSpace = async (w_id ) => {
        var data = await this._api.post("account/workspacelogin", { w_id : w_id  });
        return data;
    }

    changePass = async ({ old_pass, new_pass }) => {
        var data = await this._api.post("account/changepass", { old_pass, new_pass });
        return data;
    }





}
export default LoginServices;
